<template>
  <div class="dashboard background">
    <date-picker v-model="startDate"
      element="startDate"></date-picker>
    <date-picker
      v-model="endDate"
      element="endDate"></date-picker>
    <date-picker
      v-model="classDate"
      type="datetime"
      element="classDate"></date-picker>
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='65%' minWidth='750px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter' style="margin-bottom: 16px">
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت کلاس‌ها</h3>
            <p class='note'>کلاس جدید ایجاد کنید یا کلاس های قبلی را مدیریت کنید.
            </p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            v-if="false"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jStart aCenter fullWidth" id="tab"
          style="margin-bottom: 16px">
          <a @click="toggleSection('new')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: isNewClass}">
            <i class="material-icons-round transition-fast">
              {{!editMode ? 'add_circle' : 'edit'}}
            </i>
            <span class="transition-fast">
              {{!editMode ? 'کلاس جدید' : `ویرایش کلاس ${editData.name}`}}
            </span>
          </a>
          <a @click="toggleSection('manage')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: isManageClass}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">مدیریت کلاس‌ها</span>
          </a>
        </div>
        <!-- صفحه اضافه کردن کلاس جدید -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isNewClass'>
          <div class="fRow jBetween aStart fullWidth assignmentForm">
            <div class="fullWidth fRow jBetween aCenter wrap formSection">
              <div class="rulesMini fullWidth fRow jStart aCenter">
                <i class="material-icons-round">
                  {{!editMode ? 'add_circle' : 'edit'}}
                </i>
                <div class="fCol jCenter aStart growFull">
                  <label>
                    {{!editMode ? 'فرم ایجاد کلاس جدید' : `فرم اطلاعات کلاس ${editData.name}`}}
                  </label>
                  <span>
                    {{!editMode ?
                      'برای ایجاد کلاس جدید فرم زیر را تکمیل کنید'
                      : `اطلاعات کلاس ${editData.name} را مشاهده و در صورت نیاز ویرایش کنید`}}
                  </span>
                </div>
              <div class="b fRow jCenter aCenter" v-if="editMode" @click="toggleSection('manage')">
                <i class="material-icons-round" style="font-size: 16px">keyboard_return</i>
                <span>انصراف و بازگشت</span>
              </div>
              </div>
              <!-- عنوان کلاس -->
              <div class="fCol jStart aStart inputHolder w50">
                <span class="fRow jStart aCenter"
                  v-bind:class="{inpErr: classTitleErr}">
                  <i class="material-icons-round">title</i>
                  عنوان کلاس</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input
                    :disabled="infoMode"
                    class="transition-fast" placeholder="عنوان کلاس"
                    type="text" v-model="classTitle">
                </div>
              </div>
              <!-- تاریخ و ساعت برگزاری -->
              <div class="w25 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: classDateErr}">date_range</i>
                  تاریخ و ساعت شروع کلاس</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment" id="classDate"
                    disabled
                    class="transition-fast" placeholder="تاریخ و ساعت"
                    type="text" v-model="classDateShow">
                </div>
              </div>
              <!-- مدت زمان کلاس -->
              <div class="fCol jStart aStart inputHolder w25" >
                <span class="fRow jStart aCenter"
                  v-bind:class="{inpErr: classDurationErr}">
                  <i class="material-icons-round">timer</i>
                  مدت کلاس‌ (دقیقه)</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input
                    :disabled="infoMode"
                    class="transition-fast" placeholder="مدت به دقیقه"
                    type="number" v-model="classDuration">
                </div>
              </div>
              <!-- انتخاب سرور -->
              <div class="w60 fCol jStart aStart inputHolder" v-if="false">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: classServerErr}">dns</i>
                  سرور کلاس</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'classServer')"
                    disable-search
                    v-model="classServer"
                    :items="classServers"
                    :item-value="classServers.id"
                    :item-text="classServers.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: classServers }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ classServers.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: classServers }">
                      <div>
                        {{ classServers.title }}
                      </div>
                    </template>
                  </cool-select>
              </div>
              <div class="fRow growFull jBetween aCenter"
                v-if="!editMode || (editMode && letEditInputs)">
                <!-- انتخاب رشته -->
                <div class="w25 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classFieldErr}">biotech</i>
                    انتخاب رشته</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classField')"
                      disable-search
                      v-model="classField"
                      :items="classFields"
                      :item-value="classFields.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classFields }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classFields.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classFields }">
                        <div>
                          {{ classFields.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- انتخاب پایه -->
                <div class="w25 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classGradeErr}">clear_all</i>
                    انتخاب پایه</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classGrade')"
                      disable-search
                      v-model="classGrade"
                      :items="classGrades"
                      :item-value="classGrades.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classGrades }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classGrades.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classGrades }">
                        <div>
                          {{ classGrades.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- انتخاب درس -->
                <div class="w25 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classLessonErr}">school</i>
                    انتخاب درس</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classLesson')"
                      disable-search
                      v-model="classLesson"
                      :items="classLessons"
                      :item-value="classLessons.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classLessons }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classLessons.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classLessons }">
                        <div>
                          {{ classLessons.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- ضبط کلاس -->
                <div class="w25 fCol jStart aStart inputHolder"
                  @click="classRecord = !classRecord">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round">radio_button_checked</i>
                    ضبط کلاس</span>
                  <switch-button
                    :val='classRecord'
                    style="margin: 12px 0"
                    activeLabel='فعال'
                    deactiveLabel='غیرفعال'/>
                </div>
              </div>
              <div class="fRow growFull jBetween aCenter inps"
                v-if="editMode && !letEditInputs">
                <!-- انتخاب رشته -->
                <div class="w20 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">انتخاب رشته</span>
                  <div class="inputPreview">{{editData.lesson.grade.field.title}}</div>
                </div>
                <!-- انتخاب پایه -->
                <div class="w20 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">انتخاب پایه</span>
                  <div class="inputPreview">{{editData.lesson.grade.title}}</div>
                </div>
                <!-- انتخاب درس -->
                <div class="w20 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">انتخاب درس</span>
                  <div class="inputPreview">{{editData.lesson.title}}</div>
                </div>
                <!-- ضبط کلاس -->
                <div class="w20 fCol jStart aStart inputHolder"
                  @click="classRecord = !classRecord">
                  <span class="fRow jStart aCenter">ضبط کلاس</span>
                  <div class="inputPreview">{{editData.record ? 'ضبط فعال' : 'ضبط غیر فعال'}}</div>
                </div>
                <div class="b fRow jCenter aCenter"
                  v-if="!infoMode"
                  @click="letEditInputs = true">
                  <i class="material-icons-round">edit</i>
                  <label>ویرایش</label>
                </div>
              </div>
              <!-- توضیحات کلاس‌ -->
              <div class="fCol jStart aStart inputHolder fullWidth" >
                <span class="fRow jStart aCenter"
                  v-bind:class="{inpErr: classDescErr}">
                  <i class="material-icons-round">description</i>
                  توضیحات کلاس</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <textarea @keyup.enter="newAssignment"
                    :disabled="infoMode"
                    class="transition-fast" placeholder="توضیحات کلاس"
                    type="text" v-model="classDesc"></textarea>
                </div>
              </div>
              <!-- مدیریت فایلها  -->
              <div class="uploadersHolder fullWidth fRow jBetween aStart" v-if="editMode">
                <div class="w60 fCol jStart aStart">
                  <file-uploader
                    @activeUploaders="activeFileUploaders = true"
                    @refreshFiles="getClassFiles"
                    @uploaded="getUploadedFiles($event)"
                    :classId="classId" />
                </div>
                <div class="w40 fCol jStart aStart list">
                  <h3 class="fRow jStart aCenter secondary">
                    <i class="material-icons-round">attachment</i>
                    فایل‌های ثبت شده برای این کلاس</h3>
                  <div class="fCol jCenter aCenter fullWidth"
                    v-if="!loaded">
                    <p-bar
                      :loading="loading"
                      :notYet="notYet"
                      :noContent="noContent"
                      :notFound="notFound"
                      :error="error" />
                  </div>
                  <ul class="growFull fullWidth" v-if="loaded">
                    <li class="fullWidth fRow jStart aCenter"
                      v-for="(item, index) in classFiles" v-bind:key="index">
                      <div class="rad">{{index + 1}}</div>
                      <span class="growFull">{{item.name}}</span>
                      <i class="material-icons-round delete"
                        @click="deleteClassFile(classId, item.id)">delete</i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="fullWidth fCol jStart aStart inputHolder" style="min-height: 400px">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: selectedTeachers.length < 1}">account_circle</i>
                  انتخاب مدرس
                </span>
                <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
                  <div class="fullWidth fRow jStart aStart header wrap" v-if="!infoMode">
                    <span class="t">نام مدرس برای کلاس را انتخاب کنید:</span>
                    <input type="text" class="search fullWidth"
                      placeholder="نام مدرس را جستجو کنید"
                      v-model="teacherSearch">
                  </div>
                  <div class="items w60 fRow jBetween aCenter wrap" v-if="!infoMode">
                    <h2 class="fullWidth"
                      v-if="filteredClasses.length !== 0">مدرس را انتخاب کنید
                      از بین ({{filteredClasses.length}} مدرس)
                    </h2>
                    <div class="item fRow jStart aCenter w50 transition-fast"
                      @click="selectTeacher(item.teacherId)"
                      v-bind:class="{
                        selectedItem: selectedTeachers.includes(item.teacherId)
                      }"
                      v-for="(item, index) in filteredClasses" v-bind:key="index">
                      <i class="check material-icons-round">
                        {{!selectedTeachers.includes(item.teacherId)
                          ? 'radio_button_unchecked' : 'task_alt'}}
                      </i>
                      <div class="fCol growF">
                        <span class="name growFull">{{item.fullName}}</span>
                        <span class="name growFull mini" style="font-weight: 200; font-size: 10px">
                          {{item.summary}}</span>
                      </div>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="filteredClasses.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>نتیجه‌ای یافت نشد</span>
                      <div class="mini" @click="classSearch = ''">حذف فیلتر</div>
                    </div>
                  </div>
                  <div class="selectedItems growFull fCol jStart aCenter"
                    style="margin-right: 16px">
                    <h2 class="fullWidth">مدرس انتخاب شده:</h2>
                    <div class="item fRow jStart aCenter fullWidth transition-fast"
                      v-for="(item, index) in selectedTeacherItems" v-bind:key="index">
                      <span class="index" v-if="!infoMode">{{index + 1}}</span>
                      <span class="name growFull">{{item.fullName}}</span>
                      <i class="ac material-icons-round"
                        v-if="!infoMode"
                        @click="deleteTeacher(item.id)">delete</i>
                    </div>
                    <div class="noResult fCol fullWidth jCenter aCenter"
                      v-if="selectedTeacherItems.length === 0">
                      <i class="material-icons-round">error</i>
                      <span>هیچ کلاسی انتخاب نشده</span>
                      <!-- <div class="mini"></div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="fRow jStart aCenter fullWidth">
                <div class="b fRow jStart aCenter big" @click="newClass"
                  v-if="!editMode"
                  v-bind:class="{active: isClassFormReady}">
                  <i class="material-icons-round">done_all</i>
                  <label>ثبت کلاس جدید</label>
                </div>
                <div class="b fRow jStart aCenter big" @click="editClass"
                  v-if="editMode"
                  v-bind:class="{active: isEditClassFormReady}">
                  <i class="material-icons-round">save</i>
                  <label>ثبت تغییرات</label>
                </div>
                <div class="b fRow jStart aCenter mini" @click="clearNewClassForm">
                  <i class="material-icons-round">delete</i>
                  <label>پاک کردن فرم</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- صفحه انتخاب دانش آموزان -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isManageClass'>
          <div class="fullWidth fRow jBetween aCenter wrap formSection">
            <div class="rulesMini fullWidth fRow jStart aCenter">
              <i class="material-icons-round">settings_suggest</i>
              <div class="fCol jCenter aStart growFull">
                <label>مشاهده و عملیات</label>
                <span>کلاس مورد نظر را جستجو کنید و عملیات مورد نظر را انجام دهید</span>
              </div>
            </div>
            <div class="fRow jBetween aCenter fullWidth wrap" style="margin: 0 0 16px 0">
              <!-- عنوان کلاس -->
              <div class="fCol jStart aStart inputHolder w50">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: classSearchErr}">title</i>
                  عنوان کلاس</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast" placeholder="عنوان کلاس"
                    v-model="classSearch"
                    type="text">
                </div>
              </div>
              <div class="fCol jStart aStart inputHolder w50">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: classRangeErr}">date_range</i>
                  بازه زمانی</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast" placeholder="عنوان کلاس"
                    id="classRange"
                    disabled
                    v-model="classRangeShow"
                    type="text">
                </div>
              </div>
              <vpdp v-model="classRange" range element="classRange"/>
              <div class="fRow jStart aCenter fullWidth">
                <div class="fRow growFull jBetween aCenter">
                  <!-- انتخاب رشته -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classFieldErr}">biotech</i>
                      انتخاب رشته</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classField')"
                        disable-search
                        v-model="classField"
                        :items="classFields"
                        :item-value="classFields.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classFields }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classFields.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classFields }">
                          <div>
                            {{ classFields.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <!-- انتخاب پایه -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classGradeErr}">clear_all</i>
                      انتخاب پایه</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classGrade')"
                        disable-search
                        v-model="classGrade"
                        :items="classGrades"
                        :item-value="classGrades.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classGrades }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classGrades.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classGrades }">
                          <div>
                            {{ classGrades.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <!-- انتخاب درس -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classLessonErr}">school</i>
                      انتخاب درس</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classLesson')"
                        disable-search
                        v-model="classLesson"
                        :items="classLessons"
                        :item-value="classLessons.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classLessons }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classLessons.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classLessons }">
                          <div>
                            {{ classLessons.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                </div>
                <div class="b fRow jCenter aCenter big"
                  v-bind:class="{active: isManageFormReady}"
                  @click="getClasses"
                  style="margin: 12px 16px 0 0;">
                  <i class="material-icons-round">search</i>
                  <label>جستجو</label>
                </div>
              </div>
            </div>
            <div class="classList fCol jStart aStart fullWidth" v-if="loaded">
              <div class="classItem fRow jStart aCenter fullWidth"
                v-for="(item, index) in getClassResult" v-bind:key="index">
                <div class="classIndex">{{index + 1}}</div>
                <div class="fCol jCenter aStart growFull">
                  <div class="className">{{item.name}}
                    <div class="badge"
                    v-bind:class="{
                      now: checkDate(item.startAt, item.duration).status === 'now',
                      today: checkDate(item.startAt, item.duration).status === 'future'
                        && checkDate(item.startAt, item.duration).today,
                      future: checkDate(item.startAt, item.duration).status === 'future'
                        && !checkDate(item.startAt, item.duration).today,
                      passed: checkDate(item.startAt, item.duration).status === 'passed',
                    }">{{checkDate(item.startAt, item.duration).title}}</div>
                  </div>
                  <div class="classTeacher fRow jStart aCenter">
                    <i class="material-icons-round">school</i>
                    {{item.teacherFullName}}</div>
                </div>
                <div class="fCol jCenter aCenter cItem" title="عنوان درس">
                  <i class="material-icons-round">menu_book</i>
                  <span>{{item.lesson.title}}</span>
                </div>
                <div class="fCol jCenter aCenter cItem" title="تاریخ برگزاری کلاس">
                  <i class="material-icons-round">date_range</i>
                  <span>{{formatDate(item.startAt).date}}</span>
                </div>
                <div class="fCol jCenter aCenter cItem" title="ساعت برگزاری کلاس">
                  <i class="material-icons-round">schedule</i>
                  <span>{{formatDate(item.startAt).time}}</span>
                </div>
                <div class="fCol jCenter aCenter cItem" title="مدت زمان کلاس">
                  <i class="material-icons-round">timelapse</i>
                  <span>{{item.duration}} دقیقه</span>
                </div>
                <div class="classActions fRow jCenter aCenter">
                  <!-- اکشن های کلاس حال حاضر -->
                  <div class="actionsNow fRow jCenter aCenter"
                    v-if="checkDate(item.startAt, item.duration).status === 'now'">
                    <i class="action material-icons-round transition-fast"
                      title="ورود به کلاس"
                      @click="joinClass(item.id)">login</i>
                    <i class="action material-icons-round transition-fast"
                      @click="goInfo(item)"
                      title="اطلاعات کلاس">info</i>
                  </div>
                  <!-- اکشن های کلاس گذشته -->
                  <div class="actionsNow fRow jCenter aCenter"
                    v-if="checkDate(item.startAt, item.duration).status === 'passed'">
                    <i class="action material-icons-round transition-fast"
                      title="مشاهدۀ ویدیوها"
                      @click="watchVideos(item)">videocam</i>
                    <i class="action material-icons-round transition-fast"
                      @click="goInfo(item)"
                      title="اطلاعات کلاس">info</i>
                    <i class="action material-icons-round transition-fast"
                      title="حذف کلاس"
                      @click="doClassAction('delete', item)">delete</i>
                  </div>
                  <!-- اکشن های کلاس آینده -->
                  <div class="actionsNow fRow jCenter aCenter"
                    v-if="checkDate(item.startAt, item.duration).status === 'future'">
                    <i class="action material-icons-round transition-fast"
                      title="مشاهده و ویرایش"
                      @click="goEdit(item)">edit</i>
                    <i class="action material-icons-round transition-fast"
                      title="حذف کلاس"
                      @click="doClassAction('delete', item)">delete</i>
                  </div>
                </div>
                <div class="deleteBox fRow jStart aCenter" v-if="deleteId === item.id">
                  <i class="material-icons-round del">delete</i>
                  <div class="fCol deleteQuestion jCenter aStart">
                    <div class="q">آیا از حذف {{item.name}} مطمئنید؟</div>
                    <div class="d">این عملیات امکان بازگشت ندارد</div>
                  </div>
                  <div class="dbtn fRow jCenter aCenter" @click="deleteClass(item)">
                    <i class="material-icons-round">delete_sweep</i>
                    <label>بله مطمئنم، حذف شود</label>
                  </div>
                  <div class="mbtn fRow jCenter aCenter mini" @click="deleteId = ''">
                    <i class="material-icons-round">close</i>
                    <label>انصراف</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- loading -->
          <div class="fCol jCenter aCenter fullWidth">
            <!-- v-if="loading || noContent"> -->
            <p-bar
              :loading="loading"
              :notYet="notYet"
              :noContent="noContent"
              :notFound="notFound"
              :error="error" />
          </div>
          <!-- pagination -->
          <div class="fRow jStart aCenter fullWidth" v-if="false">
            <pagination :active='activePage' :psize='pageSize'
              @resetPageSize="resetPageSize($event)"
              :pages='howManyPages' @goToPage="GoToPages($event)" />
          </div>
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px" class="fCol jStart aCenter watchList">
        <label class="question">مشاهده‌ی ویدیوهای {{watchData.name}}</label>
        <div class="fCol jStart aCenter fullWidth videoList"
          v-if="classVideosLoaded">
          <div class="videoItem fRow fullWidth jBetween aCenter"
            v-for="(item, index) in classVideos" v-bind:key="index">
            <span class="videoName growFull">name</span>
            <i class="material-icons-round wAction">visibility</i>
            <i class="material-icons-round wAction delete">delete</i>
          </div>
        </div>
        <!-- loading -->
        <span class="wait fullWidth fCol jCenter aCenter"
          v-if="!classVideosLoaded">
          <i class="material-icons-round">autorenew</i>
          در حال دریافت ویدیوها</span>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import SwitchButton from '@/components/SwitchButton.vue';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import { CoolSelect } from 'vue-cool-select';
import moment from 'moment-jalaali';
import Pagination from '@/components/Pagination.vue';
import pBar from '@/components/pBar.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import Vpdp from 'vue-persian-datetime-picker';
import FileUploader from '@/components/ClassFileUploader.vue';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: true,
      loaded: true,
      modeMsg: '',
      // modes ↑
      isNewClass: false,
      isManageClass: false,
      isExamList: false,
      isBank: true,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      questionBank: [
        {
          id: 0,
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ؟',
          img: '',
          level: 'easy',
        },
        {
          id: 1,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد؟',
          img: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
          level: 'hard',
        },
        {
          id: 2,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد ؟',
          img: '',
          level: 'hard',
        },
        {
          id: 3,
          title: 'تمام و دشواری موجود در ارائه؟',
          img: '',
          level: 'normal',
        },
        {
          id: 4,
          title: 'شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی؟',
          img: '',
          level: 'hard',
        },
        {
          id: 5,
          title: 'جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد؟',
          img: '',
          level: 'easy',
        },
      ],
      // simple example of items
      field: '',
      fieldErr: true,
      plans: [
        {
          id: 0,
          title: 'رشته را انتخاب کنید',
        },
      ],
      plan: '',
      planErr: true,
      conventions: [
        {
          id: 0,
          title: 'لیست مشاور از وب سرویس',
        },
      ],
      convention: '',
      conventionErr: true,
      // there will be a selected item
      fieldSelected: '',
      // other
      modalShow: false,
      name: '',
      nameErr: true,
      lastName: '',
      lastNameErr: true,
      // parents ↓
      father: '',
      fatherErr: true,
      fatherJob: '',
      fatherJobErr: true,
      fatherEdu: '',
      fatherEduErr: true,
      fatherPhone: '',
      fatherPhoneErr: true,
      mother: '',
      motherErr: true,
      motherJob: '',
      motherJobErr: true,
      motherEdu: '',
      motherEduErr: true,
      motherPhone: '',
      motherPhoneErr: true,
      // parents ↑
      melli: '',
      melliErr: true,
      studentPhone: '',
      studentPhoneErr: true,
      // convention form
      conventionName: '',
      adNameErr: true,
      conventionFamily: '',
      adFamilyErr: true,
      conventionPhone: 0,
      adPhoneErr: true,
      conventionsData: [],
      // pagination
      howManyPages: 0,
      pageSize: 10,
      activePage: 1,
      // اطلاعات دانش آموزان
      studentsList: [],
      sSearch: '',
      studentData: {
        firstName: 'مهدی',
        lastName: 'کاظمی',
      },
      // moasese
      company: [
        {
          name: 'ریمیک',
          icon: 'rimik',
          id: 0,
        },
        {
          name: 'هدف سازان',
          icon: 'rimik',
          id: 1,
        },
        {
          name: 'ورتــــا',
          icon: 'rimik',
          id: 2,
        },
        {
          name: 'دکتر بشیرپور',
          icon: 'rimik',
          id: 2,
        },
      ],
      selectedCompany: -1,
      // accounting
      payments: [],
      paymentLoad: false,
      // class
      classTitle: '',
      classTitleErr: true,
      classDesc: '',
      classDescErr: true,
      classDuration: 60,
      classDurationErr: false,
      classServers: [
        {
          id: 1,
          title: 'Big Blue Button',
        },
        {
          id: 2,
          title: 'Adobe Connect',
        },
      ],
      classServer: '',
      classServerErr: true,
      classGrades: [
        {
          id: -1,
          title: 'رشته را انتخاب کنید',
        },
      ],
      classGrade: {},
      classGradeErr: true,
      classFields: [
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      classField: {},
      classFieldErr: true,
      classLessons: [
        {
          id: -1,
          title: 'ابتدا پایه را انتخاب کنید',
        },
      ],
      classLesson: {},
      classLessonErr: true,
      classDate: '',
      classDateShow: '',
      classDateErr: true,
      classOptions: [
        {
          type: 'delete',
          icon: 'delete',
          tooltip: 'حذف کلاس',
        },
        {
          type: 'join',
          icon: 'login',
          tooltip: 'ورود به کلاس',
        },
        // {
        //   type: 'copyLinkHost',
        //   icon: 'content_copy',
        //   tooltip: 'کپی لینک برای میزبان',
        // },
        {
          type: 'recorded',
          icon: 'play_arrow',
          tooltip: 'مشاهده‌ی ویدیو',
        },
      ],
      classRecord: false,
      // manage class
      classRange: '',
      classRangeShow: '',
      classRangeErr: true,
      classSearch: '',
      classSearchErr: true,
      isTyping: false,
      isTypingInterval: null,
      sec: 0,
      // new
      editMode: false,
      editData: {},
      infoMode: false,
      infoData: {},
      deleteId: '',
      letEditInputs: false,
      teachers: [],
      selectedTeachers: [],
      selectedTeachersErr: true,
      teacherSearch: '',
      selectedTeacherItems: [],
      // get class
      getClassResult: [],
      // watch videos
      watchData: {},
      classVideos: [],
      classVideosLoaded: false,
      classVideoMessage: '',
      classId: '',
      classFiles: [],
    };
  },
  methods: {
    getClassFiles() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/files/${this.classId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.courseFiles = response.data.data;
          if (this.courseFiles.length === 0) {
            this.setMode('noContent');
          } else {
            this.setMode('loaded');
            this.classFiles = response.data.data;
          }
        } else {
          this.setMode('error', 'مشکلی پیش آمده است');
        }
      }, (error) => {
        this.setMode('error', this.errorHandler(error));
      }).catch(() => {
        this.setMode('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید');
      });
    },
    deleteClassFile(classId, fileId) {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/file/${classId}/${fileId}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.makeToast('success', 'فایل با موفقیت حذف شد', 3000);
          this.getClassFiles();
        } else {
          this.makeToast('warning', 'خطا در حذف فایل', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      }).catch(() => {
        this.makeToast('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید', 3000);
      });
    },
    getUploadedFiles(e) {
      console.log(e);
    },
    refreshFiles() {
      console.log('refresh class files');
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    getTeacherPhoto() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.teacherId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // console.log(this.posts);
          this.teacherImg = this.posts.data.user.avatar;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    addNewUploader() {
      // alert(event);
      this.isVideoUploading = true;
      this.uploaderCount += 1;
      this.uploaderArray.push(this.uploaderCount.toString());
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.isNewClass = false;
      this.isManageClass = false;
      switch (order) {
        case 'new': {
          this.isNewClass = true;
          this.getTeachers();
          break;
        }
        case 'manage': {
          this.editData = {};
          this.editMode = false;
          this.infoMode = false;
          this.clearNewClassForm();
          this.isManageClass = true;
          break;
        }
        default:
          break;
      }
    },
    resetInputs() {
      // this.classField
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'classServer': {
          // console.log(this.classServer.id);
          break;
        }
        case 'classField': {
          // console.log(this.classField.id);
          // this.classGradeErr = true;
          this.classGrade = {};
          // this.classLessonErr = true;
          this.classLesson = {};
          this.getGrades(this.classField.id);
          break;
        }
        case 'classGrade': {
          // console.log(this.classGrade.id);
          // this.classLessonErr = true;
          this.classLesson = {};
          this.getLessons(this.classGrade.id);
          break;
        }
        case 'classLesson': {
          // console.log(this.classLesson.id);
          if (!this.isManageClass) {
            // this.getTeachers();
          }
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    GoToPages(event) {
      if (event === 'next') {
        // alert('next');
        this.activePage += 1;
        if (this.activePage > this.howManyPages) {
          this.activePage = 1;
        }
        this.getStudents(this.activePage);
        return;
      }
      if (event === 'prev') {
        this.activePage -= 1;
        if (this.activePage < 1) {
          this.activePage = this.howManyPages;
        }
        this.getStudents(this.activePage);
        return;
      }
      this.getStudents(event);
      this.activePage = event;
    },
    // dynamic fields
    getFields() {
      this.classFields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data.length === 0) {
            this.classGrade = {};
            this.classLesson = {};
            this.classFields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            const arr = response.data.data;
            // this.classGradeErr = true;
            this.classGrade = {};
            // this.classLessonErr = true;
            this.classLesson = {};
            this.classFields = [];
            for (let i = 0; i < arr.length; i += 1) {
              const item = {
                id: arr[i].id,
                title: arr[i].title,
              };
              this.classFields.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.classFields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classFields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    // class get grade
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== '') {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      } else {
        return;
      }
      this.classGrades = [
        {
          id: -1,
          title: 'صبر کنید',
        },
      ];
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classGrades = [];
          const arr = response.data.data;
          // this.classLessonErr = true;
          this.classLesson = {};
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i += 1) {
              this.classGrades.push({
                id: arr[i].id,
                title: arr[i].title,
              });
            }
          } else {
            this.classGrades = [
              {
                id: -1,
                title: 'هیچ پایه‌ای ثبت نشده است',
              },
            ];
          }
          // console.warn(this.grades);
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classGrades = [
          {
            id: -1,
            title: 'خطا در دریافت پایه‌ها',
          },
        ];
        // console.log(error);
      }).catch(() => {
        this.classGrades = [
          {
            id: -1,
            title: 'خطا در دریافت پایه‌ها',
          },
        ];
      });
    },
    getLessons(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== '') {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classLessons = [];
          const arr = response.data.data;
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i += 1) {
              this.classLessons.push({
                id: arr[i].id,
                title: arr[i].title,
              });
            }
          } else {
            this.classLessons = [
              {
                id: -1,
                title: 'هیچ درسی ثبت نشده',
              },
            ];
          }
          // console.warn(this.classLessons);
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classLessons = [
          {
            id: -1,
            title: 'خطا در دریافت درس‌ها',
          },
        ];
        // console.log(error);
      }).catch(() => {
        this.classGclassLessonsrades = [
          {
            id: -1,
            title: 'خطا در دریافت درس‌ها',
          },
        ];
      });
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    doClassAction(a, e) {
      switch (a) {
        case 'delete': {
          this.deleteId = e.id;
          break;
        }
        default:
          break;
      }
    },
    handleGetStudent() {
      if (this.sSearch !== '') {
        this.getStudentsSearch();
      } else {
        this.getStudents();
      }
    },
    getStudents(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Users/students?pageNo=${tpage}&pageSize=${this.pageSize}`;
      // const url = 'https://api.rimik.ir/api/v1/Users/studnets?pageNo=1&pageSize=10';
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getStudentsSearch(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Users/student/search?pageNo=${tpage}&pageSize=${this.pageSize}&search=${this.sSearch}`;
      // const url = 'https://api.rimik.ir/api/v1/Users/studnets?pageNo=1&pageSize=10';
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    resetPageSize(e) {
      this.pageSize = e;
      this.activePage = 1;
      this.getStudents();
    },
    getConventions() {
      this.setMode('loading');
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Conventions/consultant`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
            // console.log('----', this.conventionsData);
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    newConventions() {
      if (this.isConventionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Conventions/consultant`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.conventionName,
            lastName: this.conventionFamily,
            phoneNumber: `98${this.conventionPhone.slice(1, 11)}`,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه جدید با موفقیت ثبت شد', 3000);
            this.clearConsultantForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    // new class
    newClass() {
      if (this.isClassFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/create`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.classTitle,
            description: this.classDesc,
            meetingId: this.generateCode('rimik', 8),
            attendeePassword: this.generateCode('ri', 8),
            moderatorPassword: this.generateCode('ri', 8),
            status: true,
            lessonId: this.classLesson.id,
            teacherId: this.selectedTeachers[0],
            startAt: this.classDate,
            endDate: moment(this.classDate, 'YYYY-MM-DDTHH:mm:ss')
              .add(this.classDuration, 'minutes')
              .locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            record: this.classRecord,
            duration: this.classDuration,
            type: 1,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'کلاس جدید با موفقیت ثبت شد', 3000);
            this.clearNewClassForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}. درستی شماره را بررسی نمایید`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    // edit class
    editClass() {
      if (this.isEditClassFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/${this.editData.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.classTitle,
            description: this.classDesc,
            meetingId: this.generateCode('rimik', 8),
            attendeePassword: this.generateCode('ri', 8),
            moderatorPassword: this.generateCode('ri', 8),
            status: true,
            lessonId: this.letEditInputs ? this.classLesson.id : this.editData.lesson.id,
            teacherId: this.selectedTeachers[0],
            startAt: this.classDate,
            endDate: moment(this.classDate, 'YYYY-MM-DDTHH:mm:ss')
              .add(this.classDuration, 'minutes')
              .locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            record: this.classRecord,
            duration: this.classDuration,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // this.getConventions();
            this.makeToast('success', 'کلاس جدید با موفقیت ثبت شد', 3000);
            this.clearNewClassForm();
            this.toggleSection('manage');
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}. درستی شماره را بررسی نمایید`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    clearNewClassForm() {
      this.classTitle = '';
      this.classDesc = '';
      this.classDate = '';
      this.classServer = '';
      this.classServerErr = true;
      this.classGrade = {};
      // this.classGradeErr = true;
      this.classField = {};
      // this.classFieldErr = true;
      this.classLesson = {};
      // this.classLessonErr = true;
      this.getClassResult = [];
      this.setMode('notYet');
      this.selectedTeachers = [];
      this.selectedTeacherItems = [];
      // console.log(this.classGradeErr);
    },
    clearConsultantForm() {
      this.conventionName = '';
      this.conventionFamily = '';
      this.conventionPhone = '';
    },
    // getPayments
    getPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments/${this.data.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.payments = response.data.data;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // get teachers
    getTeachers(f, p) {
      // alert(f);
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/?type=1&query=null&pageNo=${tpage}&pageSize=${400}`;
      if (!this.classLessonErr) {
        // eslint-disable-next-line
        reqUrl = `${this.baseURL}/api/v${this.V}/Teachers?type=2&query=${this.classLesson.id}&pageNo=${tpage}&pageSize=${400}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          this.teachers = response.data.data.teachers;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    // get classes
    getClasses() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/${this.searchQuery}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.setMode('loaded');
          const r = response.data.data;
          this.getClassResult = [];
          if (r.length > 0) {
            this.getClassResult = r;
          } else {
            this.setMode('noContent');
          }
        } else {
          this.setMode('error', response.data.message);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'خطای فنی');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    selectTeacher(id) {
      // const isThere = this.selectedTeachers.indexOf(id);
      // if (isThere === -1) {
      //   this.selectedTeachers.push(id);
      // } else {
      //   this.selectedTeachers.splice(isThere, 1);
      // }
      this.selectedTeachers = [id];
      // console.log(this.selectedConsultants);
    },
    deleteTeacher(i) {
      // console.log(i);
      const index = this.selectedTeachers.indexOf(i);
      this.selectedTeachers.splice(index, 1);
    },
    generateCode(pre, len) {
      let p = `${pre}`;
      for (let i = 1; i <= len; i += 1) {
        if (i % 3 !== 0) {
          p += Math.floor(Math.random() * (9 - 0 + 1) + 0);
        } else {
          p += String.fromCharCode(Math.floor(Math.random() * (122 - 97 + 1) + 97));
        }
      }
      return p;
    },
    // join classes
    joinClass(u) {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/join/${u}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          meetingId: u,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          // this.setMode('loaded');
          const r = response.data.data;
          this.getClassResult = [];
          if (r.length > 0) {
            this.getClassResult = r;
          } else {
            // this.setMode('noContent');
          }
        } else {
          // this.setMode('error', response.data.message);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        // this.setMode('error', 'خطای فنی');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // format date
    formatDate(d) {
      const a = {
        time: '',
        date: '',
      };
      a.time = moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('HH:mm');
      a.date = moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('jDD jMMMM jYYYY');
      return a;
    },
    // goEdit
    goEdit(e) {
      console.log(e);
      this.editMode = true;
      this.editData = e;
      this.toggleSection('new');
      this.classId = e.id;
      this.classTitle = e.name;
      this.classDuration = e.duration;
      this.classDate = e.startAt;
      this.classDesc = e.description;
      this.selectedTeachers = [e.teacherId];
      this.getClassFiles();
    },
    // goInfo
    goInfo(e) {
      this.infoMode = true;
      this.goEdit(e);
    },
    // delete class
    deleteClass(item) {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/${item.id}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.makeToast('error', `کلاس ${item.name} با موفقیت حذف شد`, 3000);
          this.getClasses();
          // console.warn(this.grades);
        } else {
          // this.responseFalse = true;
          this.makeToast('error', `خطا در حذف ${item.name}`, 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.makeToast('error', `خطا در حذف ${item.name}`, 3000);
      });
    },
    // check classes by time and date
    checkDate(date, duration) {
      const classDateRange = {
        start: date,
        end: moment(date, 'YYYY-MM-DDTHH:mm:ss')
          .locale('en')
          .add(duration, 'm')
          .format('YYYY-MM-DDTHH:mm:ss'),
      };
      // momentize datas ↓
      const now = moment(new Date());
      const s = moment(classDateRange.start);
      const e = moment(classDateRange.end);
      // calculate diffs
      const diffStart = now.diff(s);
      const diffEnd = now.diff(e);
      let finalCheck = '';
      let label = '';
      let isToday = false;
      if (diffStart > 0 && diffEnd > 0) {
        finalCheck = 'passed';
        label = now.diff(s, 'days');
        if (label === 0) {
          isToday = true;
          label = now.diff(s, 'hours');
          if (label === 0) {
            label = now.diff(s, 'minutes');
            label += ' دقیقه پیش';
          } else {
            label += ' ساعت پیش';
          }
        } else if (label === 1) {
          label = 'دیروز';
        } else {
          label += ' روز پیش';
        }
      }
      if (diffStart > 0 && diffEnd < 0) {
        isToday = true;
        finalCheck = 'now';
        label = 'در حال برگزاری';
      }
      if (diffStart < 0 && diffEnd < 0) {
        finalCheck = 'future';
        label = e.diff(now, 'days');
        if (label === 0) {
          isToday = true;
          label = s.diff(now, 'hours');
          if (label === 0) {
            label = s.diff(now, 'minutes');
            label += ' دقیقه دیگر';
          } else {
            label += ' ساعت دیگر';
          }
        } else if (label === 1) {
          label = 'فردا';
        } else {
          label += ' روز دیگر';
        }
      }
      return {
        status: finalCheck,
        title: label,
        today: isToday,
      };
    },
    // watch
    watchVideos(e) {
      this.watchData = e;
      this.modalShow = true;
      this.getClassVideos();
    },
    // get videos
    getClassVideos() {
      this.classVideosLoaded = false;
      this.classVideoMessage = 'لطفا کمی صبر کنید';
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/record/${this.watchData.meetingId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classVideosLoaded = true;
          const r = response.data.data;
          this.classVideos = [];
          if (r.length > 0) {
            this.classVideos = r;
          } else {
            this.classVideosLoaded = false;
            this.classVideoMessage = 'ویدیویی برای این کلاس ثبت نشده';
          }
        } else {
          this.classVideosLoaded = false;
          this.classVideoMessage = response.data.message;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classVideosLoaded = false;
        this.classVideoMessage = this.errorHandler(error);
        // console.log(error);
      }).catch(() => {
        this.classVideosLoaded = false;
        this.classVideoMessage = 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید';
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Modal,
    CoolSelect,
    Pagination,
    pBar,
    Vpdp,
    SwitchButton,
    FileUploader,
  },
  watch: {
    fieldSelected() {
    },
    name() {
      if (this.name.length === 0) {
        this.nameErr = true;
      } else if (this.name.length > 24) {
        this.name = this.name.substr(0, 24);
        this.nameErr = false;
      } else {
        this.nameErr = false;
      }
    },
    lastName() {
      if (this.lastName.length === 0) {
        this.lastNameErr = true;
      } else if (this.lastName.length > 24) {
        this.lastName = this.lastName.substr(0, 24);
        this.lastNameErr = false;
      } else {
        this.lastNameErr = false;
      }
    },
    father() {
      if (this.father.length === 0) {
        this.fatherErr = true;
      } else if (this.father.length > 40) {
        this.father = this.father.substr(0, 40);
        this.fatherErr = false;
      } else {
        this.fatherErr = false;
      }
    },
    fatherJob() {
      if (this.fatherJob.length === 0) {
        this.fatherJobErr = true;
      } else if (this.fatherJob.length > 40) {
        this.fatherJob = this.fatherJob.substr(0, 40);
        this.fatherJobErr = false;
      } else {
        this.fatherJobErr = false;
      }
    },
    fatherEdu() {
      if (this.fatherEdu.length === 0) {
        this.fatherEduErr = true;
      } else if (this.fatherEdu.length > 40) {
        this.fatherEdu = this.fatherEdu.substr(0, 40);
        this.fatherEduErr = false;
      } else {
        this.fatherEduErr = false;
      }
    },
    fatherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.fatherPhone.length > 11) {
        this.fatherPhone = this.fatherPhone.substr(0, 11);
        // console.log(this.message);
        this.fatherPhoneErr = false;
      }
      if (this.fatherPhone.match(phonePattern)
        && this.fatherPhone.charAt(0) === '0'
        && this.fatherPhone.charAt(1) === '9') {
        this.fatherPhoneErr = false;
      } else {
        this.fatherPhoneErr = true;
      }
    },
    mother() {
      if (this.mother.length === 0) {
        this.motherErr = true;
      } else if (this.mother.length > 40) {
        this.mother = this.mother.substr(0, 40);
        this.motherErr = false;
      } else {
        this.motherErr = false;
      }
    },
    motherJob() {
      if (this.motherJob.length === 0) {
        this.motherJobErr = true;
      } else if (this.motherJob.length > 40) {
        this.motherJob = this.motherJob.substr(0, 40);
        this.motherJobErr = false;
      } else {
        this.motherJobErr = false;
      }
    },
    motherEdu() {
      if (this.motherEdu.length === 0) {
        this.motherEduErr = true;
      } else if (this.motherEdu.length > 40) {
        this.motherEdu = this.motherEdu.substr(0, 40);
        this.motherEduErr = false;
      } else {
        this.motherEduErr = false;
      }
    },
    motherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.motherPhone.length > 11) {
        this.motherPhone = this.motherPhone.substr(0, 11);
        // console.log(this.message);
        this.motherPhoneErr = false;
      }
      if (this.motherPhone.match(phonePattern)
        && this.motherPhone.charAt(0) === '0'
        && this.motherPhone.charAt(1) === '9') {
        this.motherPhoneErr = false;
      } else {
        this.motherPhoneErr = true;
      }
    },
    melli() {
      if (this.melli.length === 10) {
        this.melliErr = false;
      } else if (this.melli.length > 10) {
        this.melli = this.melli.substr(0, 10);
        this.melliErr = false;
      } else {
        this.melliErr = true;
      }
    },
    startDate() {
      if (this.startDate !== '') {
        // console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.startDateShow = '';
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.endDateShow = '';
        this.etErr = true;
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    classDate() {
      if (this.classDate !== '') {
        this.classDateShow = moment(this.classDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY, ساعت HH:mm');
        this.classDateErr = false;
      } else {
        this.classDateErr = true;
        this.classDateShow = '';
      }
      // const A = moment(this.classDate, 'YYYY-MM-DDTHH:mm:ss')
      //   .add(this.classDuration, 'minutes')
      //   .locale('en').format('YYYY-MM-DDTHH:mm:ss');
    },
    classDesc() {
      if (this.classDesc.length === 0) {
        this.classDescErr = true;
      } else if (this.classDesc.length > 128) {
        this.classDesc = this.classDesc.substr(0, 128);
        this.classDescErr = false;
      } else {
        this.classDescErr = false;
      }
    },
    classTitle() {
      if (this.classTitle.length === 0) {
        this.classTitleErr = true;
      } else if (this.classTitle.length > 128) {
        this.classTitle = this.classTitle.substr(0, 128);
        this.classTitleErr = false;
      } else {
        this.classTitleErr = false;
      }
    },
    classDuration() {
      if (this.classDuration < 15 || this.classDuration === undefined) {
        this.classDurationErr = true;
      } else {
        this.classDurationErr = false;
      }
    },
    classServer() {
      if (this.classServer === '') {
        this.classServerErr = true;
      } else {
        this.classServerErr = false;
      }
    },
    classGrade() {
      if (this.classGrade.id === undefined) {
        this.classGradeErr = true;
      } else {
        this.classGradeErr = false;
      }
    },
    classField() {
      if (this.classField.id === undefined) {
        this.classFieldErr = true;
      } else {
        this.classFieldErr = false;
      }
    },
    classLesson() {
      if (this.classLesson.id === undefined) {
        this.classLessonErr = true;
      } else {
        this.classLessonErr = false;
      }
    },
    // class manager
    classSearch() {
      this.isTyping = true;
      this.sec = 2000;
      // console.warn(this.sec);
      clearInterval(this.isTypingInterval);
      this.isTypingInterval = setInterval(() => {
        this.sec -= 10;
        if (this.sec === 0) {
          clearInterval(this.isTypingInterval);
          this.isTyping = false;
          if (this.searchQuery !== '') {
            this.getClasses();
          }
        }
      }, 1);
      if (this.classSearch.length > 48) {
        this.classSearch.substr(0, 48);
      }
      this.classSearchErr = this.classSearch.length < 3
        || this.classRange.length > 48;
    },
    classRange() {
      if (this.classRange.length === 2) {
        let s = '';
        s += moment(this.classRange[0], 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jYYYY/jMM/jDD');
        s += moment(this.classRange[1], 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format(' --> jYYYY/jMM/jDD');
        this.classRangeShow = s;
        this.classRangeErr = false;
      } else {
        this.classRangeErr = true;
        this.classRangeShow = '';
      }
    },
    conventionName() {
      if (this.conventionName.length === 0) {
        this.adNameErr = true;
      } else if (this.conventionName.length > 24) {
        this.conventionName = this.conventionName.substr(0, 24);
        this.adNameErr = false;
      } else {
        this.adNameErr = false;
      }
    },
    conventionFamily() {
      if (this.conventionFamily.length === 0) {
        this.adFamilyErr = true;
      } else if (this.conventionFamily.length > 24) {
        this.conventionFamily = this.conventionFamily.substr(0, 24);
        this.adFamilyErr = false;
      } else {
        this.adFamilyErr = false;
      }
    },
    conventionPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.conventionPhone.length > 11) {
        this.conventionPhone = this.conventionPhone.substr(0, 11);
        // console.log(this.message);
        this.adPhoneErr = false;
      }
      if (this.conventionPhone.match(phonePattern)
        && this.conventionPhone.charAt(0) === '0'
        && this.conventionPhone.charAt(1) === '9') {
        this.adPhoneErr = false;
      } else {
        this.adPhoneErr = true;
      }
    },
    studentPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.studentPhone.length > 11) {
        this.studentPhone = this.studentPhone.substr(0, 11);
        // console.log(this.message);
        this.studentPhoneErr = false;
      }
      if (this.studentPhone.match(phonePattern)
        && this.studentPhone.charAt(0) === '0'
        && this.studentPhone.charAt(1) === '9') {
        this.studentPhoneErr = false;
      } else {
        this.studentPhoneErr = true;
      }
    },
    selectedTeachers() {
      this.selectedTeacherItems = [];
      for (let i = 0; i < this.teachers.length; i += 1) {
        if (this.selectedTeachers.includes(this.teachers[i].teacherId)) {
          this.selectedTeacherItems.push(this.teachers[i]);
        }
      }
      if (this.selectedTeachers.length === 0) {
        this.selectedTeachersErr = true;
      } else {
        this.selectedTeachersErr = false;
      }
    },
  },
  computed: {
    isClassFormReady() {
      const a = !this.classTitleErr
        && !this.classDescErr
        && !this.classDateErr
        && !this.classDurationErr
        && !this.classLessonErr
        && !this.selectedTeachersErr;
      return a;
    },
    isEditClassFormReady() {
      const a = !this.classTitleErr
        && !this.classDescErr
        && !this.classDateErr
        && !this.classDurationErr
        && this.editMode && !this.letEditInputs ? true : !this.classLessonErr
        && !this.selectedTeachersErr;
      return a;
    },
    isManageFormReady() {
      const a = !this.classSearchErr
        || !this.classRangeErr
        || !this.classLessonErr;
      return a;
    },
    isConventionReady() {
      const a = !this.adNameErr
        && !this.adFamilyErr
        && !this.adPhoneErr;
      return a;
    },
    filteredClasses() {
      // eslint-disable-next-line
      return this.teachers.filter((item) => item.fullName.toLowerCase().includes(this.teacherSearch.toLowerCase()));
    },
    searchQuery() {
      const search = this.classSearchErr ? '' : `name=${this.classSearch}`;
      const range = this.classRangeErr ? '' : `&startAt=${this.classRange[0]}&endAt=${this.classRange[1]}`;
      const lesson = !this.classLessonErr && this.classLesson.id !== -1
        ? `&lessonId=${this.classLesson.id}` : '';
      let a = `?${search}${range}${lesson}`;
      a = a.replace('?&', '?');
      if (a === '?') {
        a = '';
      }
      // console.log(a);
      // const a = '';
      return a;
    },
  },
  mounted() {
    this.$store.commit('setLoadingOff');
    this.getFields();
    this.toggleSection('new');
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
// new for exam ↓↓↓
.bank {
  margin-top: 16px;
  .bankList {
    width: 380px;
    min-height: 312px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
    span.h {
      padding: 16px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.11);
    }
    .filterBox {
      padding: 8px;
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: 200;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
        }
        .qAddToList {
          width: 32px;
          min-width: 32px;
          margin-right: 16px;
          i {
            font-size: 16px;
          }
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
// new for exam ↑↑↑
  .counter{
    min-width: 96px;
    label{
      font-weight: bold;
      margin-right: 8px;
      font-size: 32px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
    span{
      font-weight: 100;
      font-size: 12px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
  }
  .courseInfoHolder {
    $iw: 204px;
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
    img.c{
      width: $iw;
      height: $iw;
      border-radius: 8px;
    }
    .courseTeacher{
      font-size: 16px;
      word-spacing: -2px;
      font-weight: 400;
    }
    .courseLesson{
      font-size: 13px;
      word-spacing: 0px;
      font-weight: 400;
    }
    .courseName{
      font-size: 28px;
      word-spacing: -2px;
      font-weight: 400;
      color: #61187A;
      text-align: right;
      line-height: 1.3;
      border-right: solid 4px rgba($color: #61187A, $alpha: 1);
      padding: 0px 8px 0 0;
    }
  }
  .assignments {
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    border-radius: 8px;
    overflow: hidden;
    .heads {
      width: 100%;
      text-align: right;
      padding: 8px;
      word-spacing: -2px;
      font-size: 14px;
      color: rgba($color: white, $alpha: 1.0);
      font-weight: 400;
      background-color: #61187A;
      i {
        margin-left: 8px;
        font-size: 16px;
        color: #f0f0f0;
        padding: 8px;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-width: 480px;
      overflow: hidden auto;
      li {
        width: 100%;
        padding: 12px;
        list-style: none;
        text-align: right;
        span {
          width: 16px;
          font-size: 10px;
          font-weight: 200;
          text-align: right;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .desc {
          font-size: 10px;
          font-weight: 300;
        }
      }
    }
  }

  .infos{
    padding: 0 24px;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }

  .rules{
    margin: 24px 24px 50px;
  }

  .formSection {
    .teachers {
      .teachersResult {
        padding: 4px 8px;
        border-radius: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        box-shadow: 0 2px 8px -4px rgba($color: #000000, $alpha: 0.25);
        border: solid rgba(0, 0, 0, 0.11) 2px;
        * {
          pointer-events: none;
        }
        .ava {
          min-width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
          margin-left: 8px;
        }
        .stName {
          font-weight: 500;
          font-size: 14px;
        }
        .stPhone {
          font-size: 10px;
          font-weight: 200;
          letter-spacing: 2px;
          padding-left: 2px;
        }
      }
      .teachersResult.selected {
        border: solid rgb(127, 228, 127) 2px;
      }
      .noRes {
        padding: 32px;
        i {
          font-size: 48px;
          color: rgba($color: #000000, $alpha: 0.25);
          margin-bottom: 16px;
        }
        span {
          font-size: 16px;
          font-weight: 200;
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
    }
  }
  .classList {
    .classItem {
      padding: 24px 8px;
      border-radius: 16px;
      position: relative;
      overflow: hidden;
      .classIndex {
        width: 24px;
        font-size: 12px;
        font-weight: 300;
        text-align: right;
        color: rgba($color: #000000, $alpha: 0.25);
      }
      .className {
        font-size: 13px;
        font-weight: bold;
        text-align: right;
        .badge {
          display: inline;
          white-space: nowrap;
          margin-right: 8px;
          padding: 2px 6px;
          font-size: 8px !important;
          border-radius: 24px;
        }
        .badge.now {
          @keyframes nowAnimation {
            0% {
              box-shadow: 0 0 0 0 rgba($color: rgb(207, 171, 52), $alpha: 1.0);
            }
            100% {
              box-shadow: 0 0 0 16px rgba($color: rgb(207, 171, 52), $alpha: 0);
            }
          }
          background-color: rgba($color: rgb(207, 171, 52), $alpha: 1.0);
          color: white;
          font-weight: bold;
          animation: nowAnimation 1s cubic-bezier(1,0,0,1) infinite;
        }
        .badge.passed {
          background-color: rgba($color: rgb(92, 92, 92), $alpha: 1.0);
          color: white;
        }
        .badge.future {
          background-color: rgba($color: rgb(55, 110, 194), $alpha: 1.0);
          color: white;
        }
        .badge.today {
          background-color: rgba($color: rgb(76, 160, 76), $alpha: 1.0);
          color: white;
        }
      }
      .classTeacher {
        font-weight: 300;
        font-size: 10px;
        margin-top: 8px;
        i {
          font-size: 12px;
          margin-left: 4px;
          opacity: 0.6;
        }
      }
      .cItem {
        width: 82px;
        i {
          font-size: 12px;
        }
        span {
          font-size: 11px;
        }
      }
      .classActions {
        padding: 8px;
        border-radius: 24px;
        overflow: hidden;
        background-color: rgba($color: #000000, $alpha: 0.10);
        .action {
          font-size: 16px;
          padding: 8px;
          border-radius: 50%;
          cursor: pointer;
        }
        .action:hover {
          background-color: rgba($color: #000000, $alpha: 0.15);
          box-shadow: 0 0 8px 8px rgba($color: #000000, $alpha: 0.15);
        }
      }
      .deleteBox {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: red;
        z-index: 200;
        padding: 0 16px;
        i.del {
          font-size: 32px;
          color: white;
          text-shadow: 0 4px 0px rgba($color: #000000, $alpha: 0.25);
          margin-left: 16px;
        }
        .deleteQuestion {
          margin-left: 16px;
          .q {
            font-size: 16px;
            font-weight: bold;
            color: white;
          }
          .d {
            font-size: 12px;
            color: white;
          }
        }
        .dbtn {
          cursor: pointer;
          padding: 4px 8px;
          border-radius: 16px;
          background-color: white;
          color: #000000;
          margin-left: 8px;
          * {
            pointer-events: none;
          }
          i {
            margin-left: 4px;
            font-size: 16px;
          }
          label {
            font-size: 14px;
          }
        }
        .mbtn {
          cursor: pointer;
          padding: 4px 8px;
          border-radius: 16px;
          background-color: rgba(0, 0, 0, 0.082);
          color: #ffffff;
          * {
            pointer-events: none;
          }
          i {
            margin-left: 4px;
            font-size: 12px;
            color: white;
          }
          label {
            font-size: 12px;
            font-weight: bold;
            color: white;
          }
        }
      }
    }
    .classItem:nth-child(2n+1) {
      background-color: rgba($color: #000000, $alpha: 0.05);
    }
  }

  .ruleBox {
    padding: 0 8px;
  }

  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 16px;
    font-weight: 400;
  }

  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 8px;
    border: solid 1px rgba($color: #000000, $alpha: 0.05);
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 200;
    width: 100%;
  }

  // n
  .formHead {
    padding: 8px 0px;
    margin-bottom: 8px;
    border-right: solid 2px rgba($color: #000000, $alpha: 0.25);
    i {
      color: blue;
      margin-left: 8px;
    }
    span {
      font-size: 14px;
      font-weight: bold;
      text-align: right;
    }
  }

  .companies {
    .company {
      padding: 8px;
      border-radius: 8px;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      margin-bottom: 4px;
      .companyIcon {
        width: 40px;
        height: 40px;
        margin-left: 8px;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      span {
        font-size: 10px;
      }
      .companyName {
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
      }
    }
    .company:hover {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.45);
    }
    .company.selected {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 1);
      .companyIcon {
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
    }
  }

  .consultantHolder {
    input.search {
      outline: 0;
      margin-top: 16px;
      padding: 8px 16px;
      border: solid 1px rgba($color: #000000, $alpha: 0.35);
    }
    padding: 16px;
    .header {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
      span.t {
        font-size: 14px;
        text-align: right;
        margin-left: 16px;
        color: black;
      }
      .filters {
        span.o {
          font-size: 12px;
          font-weight: bold;
          margin-left: 16px;
        }
        .cheap {
          padding: 4px 8px;
          border-radius: 24px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          font-size: 12px;
          margin-left: 8px;
          cursor: pointer;
        }
        .cheap.selected {
          background-color: rgba($color: #273a64, $alpha: 1);
          box-shadow: 0 12px 12px -12px rgba($color: #000000, $alpha: 1);
          color: white;
        }
      }
    }
    .items {
      max-height: 450px;
      overflow: hidden auto;
      padding: 16px;
      padding-bottom: 8px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 16px;
        padding: 8px;
        margin-bottom: 8px;
        border: solid 2px rgba($color: #000000, $alpha: 0.05);
        cursor: pointer;
        i.check {
          font-size: 16px;
          margin-left: 4px;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 12px;
          font-weight: 200;
          color: #646464;
        }
      }
      .item.gone {
        display: none;
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.0);
      }
      .item:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .item.selectedItem {
        border: solid 2px rgba($color: #19b146, $alpha: 0.85) !important;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
    h2 {
      padding: 0;
      margin: 0 0 16px 0;
      font-size: 14px;
      padding-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
    }
    .selectedItems {
      padding: 16px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 24px 8px 8px 24px;
        padding: 4px 8px 4px 4px;
        cursor: pointer;
        span.index {
          margin-left: 4px;
          font-size: 10px;
          text-align: right;
          min-width: 16px;
          width: 16px;
          line-height: 1;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 10px;
          font-weight: bold;
          color: #646464;
          white-space: nowrap;
        }
        i.ac {
          font-size: 16px;
          padding: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
        }
        i.ac:hover {
          background-color: rgba($color: #000000, $alpha: 0.15);
        }
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.02);
      }
    }
    .noResult {
      height: 192px;
      i {
        font-size: 24px;
        color: rgba($color: #000000, $alpha: 0.25);
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        width: 80%;
        text-align: center;
      }
      .mini {
        font-size: 12px;
        cursor: pointer;
        margin-top: 16px;
        padding: 4px 8px;
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .mini:hover {
        background-color: rgba($color: #000000, $alpha: 0.08);
      }
    }
  }
  .inps {
    padding: 16px;
    border: solid 2px rgba($color: #000000, $alpha: 0.05);
    border-radius: 8px;
    margin-bottom: 16px;
    .inputPreview {
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 13px;
      text-align: right;
      font-weight: bold;
      width: 100%;
      background-color: rgba($color: #000000, $alpha: 0.05);
      margin-top: 8px;
    }
  }
  .watchList {
    .videoList {
      .videoItem {
        padding: 8px;
        span.videoName {
          font-size: 12px;
          font-weight: bold;
        }
        i.wAction {
          font-size: 16px;
          margin-right: 4px;
        }
        i.wAction.delete {
          font-size: 16px;
          background-color: rgba($color: #ca2323, $alpha: 0.1);
          color: white;
          margin-right: 4px;
        }
      }
      .videoItem:nth-child(odd) {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
    .wait {
      i {
        @keyframes r {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        font-size: 16px;
        margin-bottom: 16px;
        animation: r 1s cubic-bezier(1, 0, 0, 1) infinite;
      }
      text-align: center;
      padding: 24px;
      color: rgba($color: #494949, $alpha: 1.0);
      font-size: 10px;
    }
  }
  // new
  .list {
    border-radius: 8px;
    overflow: hidden;
    height: 450px;
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    h3 {
      font-size: 12px;
      font-weight: 300;
      text-align: right;
      color: white;
      padding: 8px;
      margin: 0;
      border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
      i {
        font-size: 16px;
        margin-left: 8px;
        color: rgba($color: white, $alpha: 0.70);
      }
    }
    ul {
      padding: 0;
      margin: 0;
      overflow: hidden auto;
      li {
        list-style: none;
        padding: 8px;
        border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
        .rad {
          font-size: 10px;
          text-align: right;
          width: 24px;
        }
        span {
          font-size: 12px;
          font-weight: 200;
          color: #131313;
          text-align: right;
        }
        i.delete {
          font-size: 16px;
          padding: 4px;
          border-radius: 50%;
          margin-right: 8px;
          cursor: pointer;
          color: white;
          background-color: rgba($color: #b43838, $alpha: 0.8);
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.01);
      }
    }
  }
</style>
